import { Box, Typography } from '@mui/material';
import { useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';
import { ContactProps, ContactType } from '@/models/Contact';

import AdditionalContactInfo from './AdditionalContactInfo';
import ReadOnlyAddress from '../address_components/ReadOnlyAddress';

const defaultContactType: ContactType = {
  displayEmail: true,
  displayPhone: true,
};

export default function ReadOnlyContact({
  contact,
  contactType = defaultContactType,
  programId,
}: {
  contact: ContactProps;
  contactType?: ContactType;
  programId: number;
}) {
  const { translatedText } = useContext(LocaleContext);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}
    >
      <AdditionalContactInfo title='Name' value={`${contact.firstName} ${contact.lastName}`} />

      {contactType.displayEmail && (
        <AdditionalContactInfo title={translatedText.contact.labelEmail} value={contact.email} />
      )}
      {contactType.displayPhone && (
        <AdditionalContactInfo
          title={translatedText.contact.labelPhoneNumber}
          value={contact.phone}
        />
      )}

      <ReadOnlyAddress address={contact} programId={programId} />
    </Box>
  );
}
